import SafeHtml from './SafeHtml'

export default function FeedbackContent({ correcte, isTimeout, bonneReponseTexte }) {
  const bg   = correcte ? 'bg-green-500/30' : isTimeout ? 'bg-orange-500/30' : 'bg-red-500/30'
  const icon = correcte ? '✅' : isTimeout ? '⏳' : '❌'
  return (
    <div className={`h-full rounded-2xl px-4 flex flex-col items-center justify-center gap-2 ${bg}`}>
      <span className="text-5xl">{icon}</span>
      {correcte ? (
        <p className="text-white text-xl font-semibold">Bonne réponse !</p>
      ) : (
        <>
          <p className="text-white/70 text-sm">La bonne réponse est :</p>
          <SafeHtml html={bonneReponseTexte} className="text-white text-xl font-semibold text-center leading-snug" />
        </>
      )}
    </div>
  )
}
